import templateStr from 'text!./templates/qnb-info-bar.html';

export default ['$filter', function ($filter) {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            'submission': '=gwQnbInfoBar'
        },
        controller: ['$scope', function (scope) {
            scope.$filter = $filter;
            scope.getAddress = function () {
                if (!scope.submission || !scope.submission.baseData || !scope.submission.baseData.accountHolder || !scope.submission.baseData.policyAddress) {
                    return [];
                }

                var addr = scope.submission.baseData.policyAddress;
                return [addr.addressLine1, addr.city + ', ' + addr.state + ' ' + addr.postalCode];
            };

            scope.getAccountName = function () {
                if (scope.submission.baseData.accountHolder.displayName === '0dummyname0') {
                    return undefined;
                }
                return scope.submission.baseData.accountHolder.displayName;
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/directives/QnbInfoBar.js
// module id = 1222
// module chunks = 0